import React, { Component } from 'react';
import { API, graphqlOperation } from 'aws-amplify';
import * as queries from '../graphql/queries';
import * as mutations from '../graphql/mutations';
import Pomodoro from './pomodoro.js';
import TaskRow from './taskRow';
import { applyOrder, sortableFor } from './order';
import { nestTask } from './nest';
import './subtask.css'

// Require Editor CSS files.
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/froala_editor.pkgd.min.css';

import FroalaEditorComponent from 'react-froala-wysiwyg';
import FroalaEditorView from 'react-froala-wysiwyg/FroalaEditorView';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPen, faCheck, faPlus, faUndo, faTrash, faTimes } from '@fortawesome/free-solid-svg-icons'

const PLACEHOLDER_DESCRIPTIONS = ['Learn AWS AppSync', 'creating a subtask', ''];

class Subtask extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newItem: '',
      newEstimatedPomodoro: props.data.estimatedPomodoro,
      description: '',
      editDescription: false,
      subTasks: [],
      mainTask: '',
      error: '',
      showSubTasks: false,
      nested: {},
    };

    this.handleChange = this.handleChange.bind(this);
    this.createTask = this.createTask.bind(this);
    this.modifyPomodoro = this.modifyPomodoro.bind(this);
    this.setPomodoro = this.setPomodoro.bind(this);
  }

  setPomodoro = (addPomodoroEstimate,addPomodoro) => {
    var rowData = this.props.data
    if (this.state.subTasks.data.listTasks.items.length === 1 && parseInt(addPomodoroEstimate) >= 0) {
      rowData.estimatedPomodoro = addPomodoroEstimate;
      rowData.pomodoros = addPomodoro;
    } else {
      rowData.estimatedPomodoro = (parseInt(rowData.estimatedPomodoro) + addPomodoroEstimate).toString();
      rowData.pomodoros = (parseInt(rowData.pomodoros) + addPomodoro).toString();
    }
    this.forceUpdate();
    this.props.setPomodoro(rowData.estimatedPomodoro,rowData.pomodoros);
  }

  modifyPomodoro = (doneDiff,estimateDiff) => {
    var rowData = this.props.data
    var tempEstimate = rowData.estimatedPomodoro;
    var tempPomodoro = rowData.pomodoros;
    rowData.estimatedPomodoro = Math.max((parseInt(rowData.estimatedPomodoro) + estimateDiff).toString(),0);
    rowData.pomodoros = Math.max((parseInt(rowData.pomodoros) + doneDiff).toString(),0);
    rowData.pomodoros = Math.min(rowData.pomodoros, rowData.estimatedPomodoro)
    this.forceUpdate()
    this.props.modifyPomodoro(rowData.pomodoros - tempPomodoro, rowData.estimatedPomodoro - tempEstimate)
  }

  // A child's totals were saved; re-render so our own Pomodoro re-sums them.
  childChanged = () => {
    this.forceUpdate();
  }

  componentDidMount = async() => {
    var rowData = this.props.data;
    const subTasks = await this.sortedSubTasks()
    const mainTask = await API.graphql(graphqlOperation(queries.getTask, { id: rowData.id }));
    this.setState({subTasks: subTasks, mainTask: mainTask.data.getTask, description: mainTask.data.getTask.description })
  }

  sortedSubTasks = async() => {
    var rowData = this.props.data;
    var unsortedSubTasks = await API.graphql(graphqlOperation(queries.listTasks, { filter: { parentTaskId: { eq: rowData.id }}, limit: 999999999}));
    unsortedSubTasks.data.listTasks.items.sort((a,b) => {
      if (a.state === "completed" && b.state !== "completed") {
        return 1;
      } if (a.state !== "completed" && b.state === "completed") {
        return -1;
      }
      return 0;
    })

    return unsortedSubTasks;
  }

  deleteSubTask = async (task) => {
    const child_tasks = await API.graphql(graphqlOperation(queries.listTasks, {filter: {parentTaskId: {eq: task.id}}, limit: 999999999}));
    await Promise.all(child_tasks.data.listTasks.items.map(child => this.subTaskDelete(child)))
    this.setPomodoro(task.estimatedPomodoro * -1, task.pomodoros * -1)
    await API.graphql(graphqlOperation(mutations.deleteTask, {input: {id: task.id }}));
    await this.refreshAllTasks()
  }

  toggleSubTaskComplete = async (task) => {
    if (task.state === 'completed') {
      task.state = null
      let {tableData, owner, ...graphqlUpdatedTask} = task;
      await API.graphql(graphqlOperation(mutations.updateTask, {input: graphqlUpdatedTask}));
      await this.refreshAllTasks()
    } else {
      await this.completeSubTasks(task)
    }
  }

  completeSubTasks = async (mainTask) => {
    const child_tasks = await API.graphql(graphqlOperation(queries.listTasks, {filter: {parentTaskId: {eq: mainTask.id}}, limit: 999999999}));
    const child_task_data = child_tasks.data.listTasks.items
    mainTask.pomodoros = mainTask.estimatedPomodoro
    mainTask.state = 'completed'
    let {tableData, owner, ...graphqlUpdatedTask} = mainTask;

    await API.graphql(graphqlOperation(mutations.updateTask, {input: graphqlUpdatedTask}));
    await Promise.all(child_task_data.map(subtask => {
      return this.completeSubTasks(subtask)
    }))
    await this.refreshAllTasks()
  }

  refreshAllTasks = async () => {
    const subTasks = await this.sortedSubTasks()
    this.setState({subTasks: subTasks})
  }

  subTaskDelete = async(task) => {
    const child_tasks = await API.graphql(graphqlOperation(queries.listTasks, {filter: {parentTaskId: {eq: task.id}}, limit: 999999999}));
    await Promise.all(child_tasks.data.listTasks.items.map(subtask => {
      return this.subTaskDelete(subtask)
    }))
    await API.graphql(graphqlOperation(mutations.deleteTask, {input: {id: task.id }}));
    await this.refreshAllTasks()
  }

  // Reloading our subtasks lets the units card re-sum this task's totals without the moved
  // one. Bumping `nested` remounts the target's open panel so it fetches its new subtask.
  nestUnder = async (task, target) => {
    await nestTask(task, target)
    this.setState(state => ({nested: {...state.nested, [target.id]: (state.nested[target.id] || 0) + 1}}))
    await this.refreshAllTasks()
  }

  handleChange = (event) => {
    this.setState({[event.target.name]: event.target.value});
  }

  createTask = async (event) => {
    if (event) event.preventDefault();
    var randomColor = require('randomcolor')
    var color = randomColor({hue: this.state.mainTask.color, alpha: 0.1});

    const todoDetails = {
      name: this.state.newItem.trim(),
      description: 'creating a subtask',
      color: color,
      pomodoros: 0,
      estimatedPomodoro: this.state.newEstimatedPomodoro,
      state: 'new',
      deadline: 'none',
      parentTaskId: this.props.data.id
    };
    if (todoDetails.name && this.state.newEstimatedPomodoro) {
      await API.graphql(graphqlOperation(mutations.createTask, {input: todoDetails}));
      const subTasks = await this.sortedSubTasks()
      var tempVar = this.props.data;
      tempVar.estimatedPomodoro = (parseInt(tempVar.estimatedPomodoro) + parseInt(this.state.newEstimatedPomodoro)).toString()
      this.setState({subTasks: subTasks, error: '', showSubTasks: false, newItem: ''})
      this.props.setPomodoro(this.state.newEstimatedPomodoro,0)
    } else {
      this.setState({error: 'Give the subtask a name and an estimate.'})
    }
  }

  updateTaskName = async (rowData, name) => {
    var currentTask = rowData;
    currentTask.name = name
    let {tableData, owner, ...graphqlUpdatedTask} = currentTask;
    await API.graphql(graphqlOperation(mutations.updateTask, {input: graphqlUpdatedTask}));
    await this.refreshAllTasks()
  }

  subTaskActions = (task) => {
    const isDone = task.state === 'completed';
    return [
      {
        key: 'complete',
        icon: isDone ? faUndo : faCheck,
        label: isDone ? 'Mark not done' : 'Mark done',
        tone: isDone ? null : 'success',
        onClick: this.toggleSubTaskComplete,
      },
      {
        key: 'delete',
        icon: faTrash,
        label: 'Delete subtask',
        tone: 'danger',
        confirm: true,
        onClick: this.deleteSubTask,
      },
    ];
  }

  renderSubTasks = () => {
    const listKey = 'sub.' + this.props.data.id;
    const items = applyOrder(listKey, this.state.subTasks.data.listTasks.items);
    if (items.length === 0) {
      return null;
    }
    return (
      <div className="subtask-list">
        {items.map((task) => (
          <TaskRow
            key={task.id}
            task={task}
            compact
            allowEdit={this.props.allowEdit}
            onRename={this.props.allowEdit ? this.updateTaskName : null}
            actions={this.props.allowEdit ? this.subTaskActions(task) : []}
            sortable={this.props.allowEdit ? sortableFor(this, listKey, items, task, this.nestUnder) : null}
            renderPanel={(rowData) => (
              <Subtask
                key={rowData.id + ':' + (this.state.nested[rowData.id] || 0)}
                data={rowData}
                allowEdit={this.props.allowEdit}
                setPomodoro={this.setPomodoro}
                modifyPomodoro={this.modifyPomodoro}
                onChange={this.childChanged}
              />
            )}
          />
        ))}
      </div>
    );
  }

  renderAddSubTask = () => {
    if (!this.props.allowEdit) {
      return null;
    }
    if (!this.state.showSubTasks) {
      return (
        <button className="btn btn--ghost btn--sm add-subtask-trigger" onClick={this.showSubTasks}>
          <FontAwesomeIcon icon={faPlus} /> Add subtask
        </button>
      );
    }
    return (
      <form className="subtask-form" onSubmit={this.createTask}>
        <input
          className="field subtask-form__name"
          type="text"
          autoFocus
          value={this.state.newItem}
          name="newItem"
          placeholder={'Subtask of “' + this.props.data.name + '”'}
          onChange={this.handleChange}
          aria-label="Subtask name"
        />
        <label className="subtask-form__units">
          <input
            className="field"
            type="number"
            min="1"
            value={this.state.newEstimatedPomodoro}
            name="newEstimatedPomodoro"
            onChange={this.handleChange}
            aria-label="Estimated units"
          />
          <span>units</span>
        </label>
        <button type="submit" className="btn btn--primary btn--sm">
          <FontAwesomeIcon icon={faPlus} /> Add
        </button>
        <button type="button" className="icon-btn" onClick={this.showSubTasks} title="Cancel" aria-label="Cancel">
          <FontAwesomeIcon icon={faTimes} />
        </button>
        {this.state.error && <p className="subtask-form__error">{this.state.error}</p>}
      </form>
    );
  }

  description = () => {
    var rowData = this.state.mainTask
    const hasText = PLACEHOLDER_DESCRIPTIONS.indexOf((rowData.description || '').trim()) === -1;
    if (this.state.editDescription === false) {
      return (
        <div className="notes">
          <div className="notes__head">
            <span className="eyebrow">Notes</span>
            {this.props.allowEdit && (
              <button className="icon-btn icon-btn--sm" onClick={this.editDescription} title="Edit notes" aria-label="Edit notes">
                <FontAwesomeIcon icon={faPen} />
              </button>
            )}
          </div>
          {hasText ? (
            <div className="notes__body"><FroalaEditorView model={rowData.description} /></div>
          ) : (
            <button className="notes__empty" onClick={this.props.allowEdit ? this.editDescription : undefined} disabled={!this.props.allowEdit}>
              {this.props.allowEdit ? 'Add notes, links or a checklist…' : 'No notes'}
            </button>
          )}
        </div>
      )
    } else {
      return (
        <div className="notes is-editing">
          <div className="notes__head">
            <span className="eyebrow">Notes</span>
            <button className="btn btn--primary btn--sm" onClick={this.updateDescription}>
              <FontAwesomeIcon icon={faCheck} /> Save
            </button>
          </div>
          <FroalaEditorComponent
            tag='textarea'
            model={this.state.description}
            onModelChange={this.handleDesciptionChange}
          />
        </div>
      )
    }
  }

  handleDesciptionChange = (description) => {
    this.setState({description: description })
  }

  editDescription = () => {
    const current = (this.state.description || '').trim();
    const isPlaceholder = PLACEHOLDER_DESCRIPTIONS.indexOf(current) !== -1;
    this.setState({
      editDescription: !this.state.editDescription,
      description: isPlaceholder ? '' : this.state.description,
    });
  }

  updateDescription = async () => {
    const main_task = this.state.mainTask
    main_task.description = this.state.description
    let {tableData, owner, ...graphqlUpdatedTask} = main_task;
    await API.graphql(graphqlOperation(mutations.updateTask, {input: graphqlUpdatedTask}));
    this.setState({editDescription: !this.state.editDescription, mainTask: graphqlUpdatedTask});
  }

  showSubTasks = () => {
    this.setState({showSubTasks: !this.state.showSubTasks, error: ''});
  }

  render() {
    var rowData = this.props.data
    const taskArrayData = this.state.subTasks.data;
    if (taskArrayData === undefined) {
      return (
        <div className="detail detail--loading">
          <div className="skeleton skeleton--block" />
          <div className="skeleton skeleton--line" />
        </div>
      )
    }
    const count = taskArrayData.listTasks.items.length;
    return (
      <div className="detail">
        <div className="detail__top">
          <Pomodoro
            allowEdit={this.props.allowEdit}
            row={rowData}
            subTasks={this.state.subTasks}
            modifyPomodoro={this.modifyPomodoro}
            onTotalsChange={this.props.onChange}
          />
          { this.description() }
        </div>
        <div className="detail__subtasks">
          {(count > 0 || this.props.allowEdit) && (
            <div className="detail__label">
              <span className="eyebrow">Subtasks{count > 0 ? ' · ' + count : ''}</span>
            </div>
          )}
          { this.renderSubTasks() }
          { this.renderAddSubTask() }
        </div>
      </div>
    )
  }
}

export default Subtask;
